module.exports = __webpack_public_path__ + "img/success_visit.d87f51df.png";